var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-field",on:{"click":function($event){return _vm.addField()}}},[_c('i',{staticClass:"fal fa-plus-square fa-fw text-lg"}),_c('span',[_vm._v(_vm._s(_vm.addText))])])}
var staticRenderFns = []

export { render, staticRenderFns }